'use client';

import { c as _c } from "react/compiler-runtime";
import type { usePrV2ReviewerActions } from '@/data/v2/pr/use-pr-v2-reviewer-actions';
import type { ReviewerSelection, ReviewerStateValues, TeamReviewerSelection } from '@/types/github';
import { toast } from 'sonner';
import { isCubicReviewer, toGithubReviewer } from './pr-v2-sidebar-model';
import { EditReviewersButton } from '@/components/reviewers/edit-reviewers-button';
type ReviewerUpdate = {
  toAdd: ReviewerSelection[];
  toRemove: ReviewerSelection[];
  teamsToAdd: TeamReviewerSelection[];
  teamsToRemove: TeamReviewerSelection[];
};
type PrV2ReviewerActions = Pick<ReturnType<typeof usePrV2ReviewerActions>, 'batchUpdateReviewers' | 'isMutating'>;
async function applyReviewerUpdate(reviewerActions: PrV2ReviewerActions, update: ReviewerUpdate) {
  if (update.toAdd.length === 0 && update.toRemove.length === 0 && update.teamsToAdd.length === 0 && update.teamsToRemove.length === 0) {
    return;
  }
  try {
    await reviewerActions.batchUpdateReviewers(update);
  } catch (error) {
    toast.error(error instanceof Error ? error.message : 'Failed to update reviewers');
  }
}

/**
 * The reviewer picker for a PR v2 pull request, used by the PR page sidebar and the /code PR tab.
 * cubic is left out of the editable list. The caller passes its reviewer actions so every
 * reviewer control on the surface shares one pending state.
 */
export function PrV2EditReviewersButton(t0) {
  const $ = _c(16);
  const {
    owner,
    repo,
    number,
    reviewers,
    requestedTeams,
    authorLogin,
    reviewerActions,
    enableShortcut
  } = t0;
  let t1;
  if ($[0] !== number) {
    t1 = Number.parseInt(number, 10);
    $[0] = number;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== reviewers) {
    t2 = reviewers.filter(_temp).map(toGithubReviewer);
    $[2] = reviewers;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = authorLogin ?? "";
  let t4;
  if ($[4] !== reviewerActions) {
    t4 = update => applyReviewerUpdate(reviewerActions, update);
    $[4] = reviewerActions;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== enableShortcut || $[7] !== owner || $[8] !== repo || $[9] !== requestedTeams || $[10] !== reviewerActions.isMutating || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <EditReviewersButton owner={owner} repo={repo} number={t1} reviewers={t2} requestedTeams={requestedTeams} authorLogin={t3} batchUpdateReviewers={t4} isBatchUpdating={reviewerActions.isMutating} enableShortcut={enableShortcut} />;
    $[6] = enableShortcut;
    $[7] = owner;
    $[8] = repo;
    $[9] = requestedTeams;
    $[10] = reviewerActions.isMutating;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
function _temp(reviewer) {
  return !isCubicReviewer(reviewer.login);
}